import { useEffect, useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import styles from './CadastroMesas.module.css';
import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
import MobileMenu from '../../../shared/components/MobileMenu';
import HeaderAdmin from '../components/HeaderAdmin';
import Input from "../../../shared/form/Input";
import { getAreaUrl } from '../../../shared/utils/subdomain';
import { MdAdd, MdFileDownload, MdPrint, MdBlock, MdCheckCircleOutline } from "react-icons/md";

function CadastroMesas() {
    const [mesas, setMesas] = useState([]);
    const [mostrarCriar, setMostrarCriar] = useState(false);
    const [numero_da_mesa, setNumero] = useState('');
    const [capacidade, setCapacidade] = useState('');
    const [status, setStatus] = useState('livre');
    const qrRefs = useRef({});

    const API_URL = process.env.REACT_APP_API_URL;

    const buscarMesas = async () => {
        try {
            const token = localStorage.getItem("token");
            const estabelecimento_id = localStorage.getItem("estabelecimento_id");
            const url = estabelecimento_id
                ? `${API_URL}/mesas?estabelecimento_id=${estabelecimento_id}`
                : `${API_URL}/mesas`;
            const response = await fetch(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setMesas(data);
            }
        } catch (err) {
            console.log("Erro ao buscar mesas:", err.message);
        }
    };

    useEffect(() => {
        buscarMesas();
    }, []);

    const cadastroMesa = async (e) => {
        e.preventDefault();

        if (!numero_da_mesa || !capacidade) {
            alert("Número e capacidade são obrigatórios!");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const estabelecimento_id = Number(localStorage.getItem("estabelecimento_id"));

            const response = await fetch(`${API_URL}/mesas`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ numero_da_mesa, capacidade, status, id_estabelecimento: estabelecimento_id })
            });

            if (response.ok) {
                setNumero('');
                setCapacidade('');
                setStatus('livre');
                setMostrarCriar(false);
                await buscarMesas();
            } else {
                const erro = await response.json().catch(() => ({}));
                alert(`Erro ao cadastrar a mesa: ${erro.error || 'Erro desconhecido'}`);
            }
        } catch (err) {
            alert(`Erro na requisição: ${err.message}`);
        }
    };

    const alternarStatusMesa = async (mesa) => {
        const ativar = !mesa.ativa;
        const numero = mesa.numero_da_mesa ?? mesa.id_mesa;

        if (!ativar && !window.confirm(`Desativar a mesa ${numero}? Ela deixa de aparecer para os operadores até ser reativada.`)) {
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/mesas/${mesa.id_mesa}/status`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ ativa: ativar })
            });

            if (response.ok) {
                await buscarMesas();
            } else {
                const erro = await response.json().catch(() => ({}));
                alert(`Erro ao ${ativar ? 'reativar' : 'desativar'} a mesa: ${erro.error || 'Erro desconhecido'}`);
            }
        } catch (err) {
            alert(`Erro na requisição: ${err.message}`);
        }
    };

    const baixarQrCode = (mesa) => {
        const canvas = qrRefs.current[mesa.id_mesa];
        if (!canvas) return;
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `mesa-${mesa.numero_da_mesa || mesa.id_mesa}-qrcode.png`;
        link.click();
    };

    const imprimirQrCode = (mesa) => {
        const canvas = qrRefs.current[mesa.id_mesa];
        if (!canvas) return;
        const dataUrl = canvas.toDataURL("image/png");
        const janela = window.open('', '_blank', 'width=420,height=560');
        if (!janela) return;
        janela.document.write(`
            <html>
              <head><title>Mesa ${mesa.numero_da_mesa ?? mesa.id_mesa}</title></head>
              <body style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;margin:0;font-family:sans-serif;">
                <h2>Mesa ${mesa.numero_da_mesa ?? mesa.id_mesa}</h2>
                <img src="${dataUrl}" alt="QR Code" />
                <p>Aponte a câmera para pedir</p>
              </body>
            </html>
        `);
        janela.document.close();
        janela.focus();
        janela.print();
    };

    return (
        <div className={styles.secaoPrincipal}>
            <MobileMenu />
            <SideBarGestaoAdmin />

            <div className={styles.containerDashboard}>
                <HeaderAdmin />

                <div className={styles.contentWrapper}>
                    <h2 className={styles.tituloSecao}>
                        Mesas <span className={styles.contagem}>· {mesas.length} cadastrada{mesas.length === 1 ? '' : 's'}</span>
                    </h2>

                    <div className={styles.mesasGrid}>
                        {mesas.map((mesa) => {
                            const numero = String(mesa.numero_da_mesa ?? mesa.id_mesa).padStart(2, '0');
                            const inativa = mesa.ativa === false;
                            const displayStatus = inativa ? 'inativa' : (mesa.conta_aberta ? 'ocupada' : (mesa.status || 'livre'));

                            return (
                                <div key={mesa.id_mesa} className={`${styles.mesaCard} ${inativa ? styles.mesaCardInativa : ''}`}>
                                    <div className={styles.mesaHeader}>
                                        <span className={`${styles.statusPill} ${styles['status_' + displayStatus]}`}>
                                            {displayStatus}
                                        </span>
                                        <span className={styles.mesaLabel}>Mesa</span>
                                        <span className={styles.mesaNumero}>{numero}</span>
                                    </div>

                                    <div className={styles.mesaBody}>
                                        <div className={styles.qrBox}>
                                            <QRCodeCanvas
                                                ref={(el) => { if (el) qrRefs.current[mesa.id_mesa] = el; }}
                                                value={getAreaUrl('cliente', `/mesa/${mesa.token_qrcode}`)}
                                                size={112}
                                                level="M"
                                                includeMargin={false}
                                            />
                                        </div>
                                        <p className={styles.dica}>aponte a câmera pra pedir</p>

                                        <div className={styles.acoes}>
                                            <button className={styles.acaoBtn} onClick={() => baixarQrCode(mesa)}>
                                                <MdFileDownload /> baixar
                                            </button>
                                            <button className={styles.acaoBtn} onClick={() => imprimirQrCode(mesa)}>
                                                <MdPrint /> imprimir
                                            </button>
                                            <button
                                                className={`${styles.acaoBtn} ${inativa ? styles.acaoAtivar : styles.acaoDesativar}`}
                                                onClick={() => alternarStatusMesa(mesa)}
                                            >
                                                {inativa ? <><MdCheckCircleOutline /> reativar</> : <><MdBlock /> desativar</>}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        <button className={styles.mesaCardNova} onClick={() => setMostrarCriar(true)}>
                            <span className={styles.novaCirculo}><MdAdd /></span>
                        </button>
                    </div>
                </div>
            </div>

            {mostrarCriar && (
                <div className={styles.modalOverlay} onClick={() => setMostrarCriar(false)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.modalClose} onClick={() => setMostrarCriar(false)}>×</button>
                        <h3 className={styles.modalTitulo}>Cadastrar mesa</h3>

                        <form onSubmit={cadastroMesa} className={styles.form}>
                            <Input
                                type="number"
                                text="Número da Mesa"
                                name="numero"
                                placeholder="Ex: 5"
                                value={numero_da_mesa}
                                handleOnChange={(e) => setNumero(e.target.value)}
                            />

                            <Input
                                type="number"
                                text="Capacidade"
                                name="capacidade"
                                placeholder="Ex: 4 lugares"
                                value={capacidade}
                                handleOnChange={(e) => setCapacidade(e.target.value)}
                            />

                            <div className={styles.inputGroup}>
                                <label>Status inicial</label>
                                <select
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                    className={styles.select}
                                >
                                    <option value="livre">Livre</option>
                                    <option value="reservada">Reservada</option>
                                </select>
                            </div>

                            <button className={styles.btnSalvar} type="submit">Cadastrar Mesa</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CadastroMesas;
